import { Backdrop, CircularProgress } from '@mui/material';
import React, { useState, useEffect, useRef } from 'react';
import { FiArrowLeft } from 'react-icons/fi';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import api from '../../api/api';
import ToastMessage from '../../utils/muitoast';
import { useTranslation } from 'react-i18next';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import documentData from '../../assets/document.png'
import SignatureModal from '../Signaturemodal';
import { useSearchParams } from "react-router-dom";

const BBSObservationForm = () => {
  const [currentStage, setCurrentStage] = useState(1);
  const [showEmpSuggestions, setShowEmpSuggestions] = useState(false);
  const [employeeId, setEmployeeId] = useState('');
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [employeeSuggestions, setEmployeeSuggestions] = useState([]);
   const [selectedempobj,setselectedempobj]=useState({})
const [suggestions, setSuggestions] = useState([]);
  const [jobCode, setJobCode] = useState('');
  const [selectedJobName, setSelectedJobName] = useState('');
  const [companyTabs, setCompanyTabs] = useState([]); // Replaces 'Tabs'
  const [selectedCompanyId, setSelectedCompanyId] = useState(null); // To store selected company ID
  const jobInputRef = useRef(null);
  const empInputRef = useRef(null);
  const totalStages = 5;
  const navigate = useNavigate();
  const user = useSelector((state) => state.user.userDetails);
  const [loader,setLoader]=useState(false);
  const [severity, setSeverity] = useState('success');
  const [open, setOpen] = useState(false);
  const [alertmessage, setAlertMessage] = useState('');
  const [hoveredIndex, setHoveredIndex] = useState(-1);
    const [searchParams] = useSearchParams();
       const [signaturemodal,setSignatureModal]=useState(false)
       const mode = searchParams.get("mode"); // null if not sent
const id = searchParams.get("id");     // null if not sent

  // State to store all form data
  const { t, i18n } = useTranslation(['bbssafety']); 
  const [selectedLanguage, setSelectedLanguage] = useState('en');
const [objimg,setobjimg]=useState(null)
  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang);
    setSelectedLanguage(lang);
  };

const transformDateToISO = (dateStr) => {
  if (!dateStr) return '';
  const [month, day, year] = dateStr.split('-');
  return `${year}-${month}-${day}`;
};

  const formatAPIDateToPicker = (dateStr) => {
  // API gives YYYY-MM-DD
  if (!dateStr) return "";

  const [year, month, day] = dateStr.split("-");
  return `${month}-${day}-${year}`; // return MM-DD-YYYY
};
const[editedimg,setEditedimg]=useState('')
  const [formData, setFormData] = useState({
    companyId: null,
    emp_Id:null,
    jobNumber: '',
    method:'',
    observerName: '',
    date: '',
    taskDescription: '',
    ppe: {
      eyeFace: '',
      hand: '',
      body: '',
      head: '',
      respiratory: '',
      hearing: ''
    },
    bodyPosition: {
      properBodyPositioning: '',
      manualLifting: '',
      repetition: '',
      pinchPoints: '',
      pullingPushing: '',
      extending: ''
    },
    workEnvironment: {
      slipsTripsFalls: '',
      congestedWorkArea: '',
      barricadesSignage: '',
      excavations: '',
      fallProtection: '',
      spillControl: ''
    },
    workProcedures: {
      jsaCoverTask: '',
      hazardRecognition: '',
      energyIsolation: '',
      simultaneousOperations: '',
      handPowerTools: '',
      mobileEquipment: ''
    },
    feedback: '',
    stopWorkAuthority: "",
    clientJointObservation: ''
  });



  const handleCloseToast = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };
  // Handle input changes
  const handleInputChange = (e, section, field) => {
    const { value } = e.target;
    if (section) {
      setFormData(prev => ({
        ...prev,
        [section]: {
          ...prev[section],
          [field]: value
        }
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        [field]: value
      }));
    }
  };
  const HandleSignature = (x) => {
  setobjimg(x)
  
}


  // Handle radio button changes
  const handleRadioChange = (section, field, value) => {
    if (!section) {
      setFormData(prev => ({
        ...prev,
        [field]: value
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        [section]: {
          ...prev[section],
          [field]: value
        }
      }));
    }
  };

const handleNext = () => {
    
  const step1 = {
    companyId: "Please select Company ID",
    jobNumber: "Please enter Job ID",
    // observerName: "Please enter Employee Name",
    date: "Please select a Date",
    taskDescription: "Please enter Task Description",
    method: "Please select Method"
  };

  const step2 = {
    eyeFace: "Please select Eye & Face PPE option",
    hand: "Please select Hand PPE option",
    body: "Please select Body PPE option",
    head: "Please select Head PPE option",
    respiratory: "Please select Respiratory PPE option",
    hearing: "Please select Hearing PPE option"
  };
  const step3 = {
    properBodyPositioning: "Please select Proper Body Positioning",
    manualLifting: "Please select Manual Lifting Mechanics",
    repetition: "Please select Repetition option",
    pinchPoints: "Please select Pinch Points option",
    pullingPushing: "Please select Pulling/Pushing option",
    extending: "Please select Extending option"
  };
  const step4 = {
    // Work Environment
    slipsTripsFalls: "Please select Slips, Trips, Falls option",
    congestedWorkArea: "Please select Congested Work Area option",
    barricadesSignage: "Please select Barricades/Signage option",
    excavations: "Please select Excavations option",
    fallProtection: "Please select Fall Protection option",
    spillControl: "Please select Spill Control option",
    // Work Procedures
    jsaCoverTask: "Please select JSA Cover Task option",
    hazardRecognition: "Please select Hazard Recognition option",
    energyIsolation: "Please select Energy Isolation option",
    simultaneousOperations: "Please select Simultaneous Operations option",
    handPowerTools: "Please select Hand/Power Tools option",
    mobileEquipment: "Please select Mobile Equipment option"
  };
  
  const steps = [step1, step2,step3 ,step4/*, step3, etc. */];
  const requiredFields = steps[currentStage - 1] || {};

  for (let key in requiredFields) {
    if (currentStage === 2) {
      if (!formData.ppe || !formData.ppe[key]) {
        setSeverity("error");
        setAlertMessage(requiredFields[key]);
        setOpen(true);
        return;
      }
    }else if (currentStage === 3) {
      if (!formData.bodyPosition || !formData.bodyPosition[key]) {
        setSeverity("error");
        setAlertMessage(requiredFields[key]);
        setOpen(true);
        return;
      } }else if (currentStage === 4) {
        if (
          (!formData.workEnvironment || !formData.workEnvironment[key]) &&
          (!formData.workProcedures || !formData.workProcedures[key])
        ) {
          setSeverity("error");
          setAlertMessage(requiredFields[key]);
          setOpen(true);
          return;
        }
      }else {
      if (!formData[key]) {
        setSeverity("error");
        setAlertMessage(requiredFields[key]);
        setOpen(true);
        return;
      }
    }
  }

  if (currentStage < totalStages) {
    setCurrentStage(currentStage + 1);
  }
};
const mapJsonToForm = (apiData = {}) => {
  const updated = {
    ...formData,
    ppe: { ...formData.ppe },
    bodyPosition: { ...formData.bodyPosition },
    workEnvironment: { ...formData.workEnvironment },
    workProcedures: { ...formData.workProcedures }
  };

  // ---- safety checks ----
  if (!apiData || !Array.isArray(apiData.json_data)) {
    return updated;
  }

  apiData.json_data.forEach(item => {
    if (!item || typeof item !== "object") return;

    const q = typeof item.question === "string" ? item.question : "";
    const a = item.answer;

    /* 1. Task description */
    if (q.includes("What task(s)") && typeof a === "string") {
      updated.taskDescription = a;
    }

    /* 2. PPE */
    if (q.startsWith("PPE - ") && typeof a === "string") {
      const field = q.replace("PPE - ", "").trim();
      const map = {
        "Eye & Face": "eyeFace",
        "Hand": "hand",
        "Body": "body",
        "Head": "head",
        "Respiratory": "respiratory",
        "Hearing": "hearing"
      };

      const key = map[field];
      if (key && updated.ppe) {
        updated.ppe[key] = a;
      }
    }

    /* 3. Body Position */
    if (q.startsWith("Body Position - ") && typeof a === "string") {
      const field = q.replace("Body Position - ", "").trim();
      const map = {
        "Proper Body Positioning (Line of fire)": "properBodyPositioning",
        "Manual lifting mechanics": "manualLifting",
        "Repetition": "repetition",
        "Pinch Points": "pinchPoints",
        "Pulling/Pushing": "pullingPushing",
        "Extending": "extending"
      };

      const key = map[field];
      if (key && updated.bodyPosition) {
        updated.bodyPosition[key] = a;
      }
    }

    /* 4. Work Environment */
    if (q.startsWith("Work Environment - ") && typeof a === "string") {
      const field = q.replace("Work Environment - ", "").trim();
      const map = {
        "Slips, Trips, Falls": "slipsTripsFalls",
        "Congested Work Area": "congestedWorkArea",
        "Barricades/Signage": "barricadesSignage",
        "Excavations": "excavations",
        "Fall Protection": "fallProtection",
        "Spill Control": "spillControl"
      };

      const key = map[field];
      if (key && updated.workEnvironment) {
        updated.workEnvironment[key] = a;
      }
    }

    /* 5. Work Procedures */
    if (q.startsWith("Work Procedure - ") && typeof a === "string") {
      const field = q.replace("Work Procedure - ", "").trim();
      const map = {
        "JSA Cover Task": "jsaCoverTask",
        "Hazard Recognition": "hazardRecognition",
        "Energy Isolation (LOTO)": "energyIsolation",
        "Simultaneous Operations (SIMOPS)": "simultaneousOperations",
        "Hand/Power Tools": "handPowerTools",
        "Mobile Equipment": "mobileEquipment"
      };

      const key = map[field];
      if (key && updated.workProcedures) {
        updated.workProcedures[key] = a;
      }
    }

    /* 6. Feedback */
    if (q.includes("Observer's feedback") && typeof a === "string") {
      updated.feedback = a;
    }

    /* 7. Stop Work Authority */
    if (q.includes("Stop Work Authority") && typeof a === "string") {
      updated.stopWorkAuthority = a;
    }

    /* 8. Client Joint Observation (Image/Object) */
    if (
      q.includes("Client Joint Observation") &&
      a &&
      typeof a === "object" &&
      a.file_path
    ) {
      setEditedimg(a);
    }
  });

  /* ---- top-level safe mappings ---- */
  updated.companyId =
    typeof apiData.companyid === "number" ? apiData.companyid : null;

  updated.emp_Id =
    typeof apiData.emp_id === "number" ? apiData.emp_id : null;

  updated.observerName =
    typeof apiData.emp_name === "string" ? apiData.emp_name : "";

  updated.jobNumber =
    typeof apiData.job_id === "number" 
      ? apiData.job_id
      : null;

  updated.method =
    typeof apiData.method === "string" ? apiData.method : "";

  updated.date =
    typeof apiData.filled_date === "string"
      ? formatAPIDateToPicker(apiData.filled_date)
      : "";

  return updated;
};


const fetchcurrentformdata=async()=>{
  try {
    setLoader(true)
     const res = await api.get(`/v1/forms/get_by_id`,{
      params:{
          rowid:id
        }
      });
   if (res.status === 200) {
      const apiData = res.data[0];

      const mapped = mapJsonToForm(apiData);

      setFormData(mapped);
    }
    
  } catch (error) {
    console.log(error)
  }finally{
setLoader(false)
  }
}

useEffect(() => {
  if (mode === "edit" && id) {
  fetchcurrentformdata()
  }
}, [mode, id]);
  const handlePrevious = () => {
    if (currentStage > 1) {
      setCurrentStage(currentStage - 1);
    }
  };

  const generateJsonData = async(formData) => {
    const json = [];
  
    // Question: Task Description
    if (formData.taskDescription) {
      json.push({
        question: "What task(s) were employee(s) performing during the BBS observation?",
        answer: formData.taskDescription
      });
    }
  
    // Mapping labels
    const mappings = [
      {
        section: formData.ppe,
        prefix: "PPE",
        labels: {
          eyeFace: "Eye & Face",
          hand: "Hand",
          body: "Body",
          head: "Head",
          respiratory: "Respiratory",
          hearing: "Hearing"
        }
      },
      {
        section: formData.bodyPosition,
        prefix: "Body Position",
        labels: {
          properBodyPositioning: "Proper Body Positioning (Line of fire)",
          manualLifting: "Manual Lifting Mechanics",
          repetition: "Repetition",
          pinchPoints: "Pinch Points",
          pullingPushing: "Pulling/Pushing",
          extending: "Extending"
        }
      },
      {
        section: formData.workEnvironment,
        prefix: "Work Environment",
        labels: {
          slipsTripsFalls: "Slips, Trips, Falls",
          congestedWorkArea: "Congested Work Area",
          barricadesSignage: "Barricades/Signage",
          excavations: "Excavations",
          fallProtection: "Fall Protection",
          spillControl: "Spill Control"
        }
      },
      {
        section: formData.workProcedures,
        prefix: "Work Procedure",
        labels: {
          jsaCoverTask: "JSA Cover Task",
          hazardRecognition: "Hazard Recognition",
          energyIsolation: "Energy Isolation (LOTO)",
          simultaneousOperations: "Simultaneous Operations (SIMOPS)",
          handPowerTools: "Hand/Power Tools",
          mobileEquipment: "Mobile Equipment"
        }
      }
    ];
  
    mappings.forEach(({ section, prefix, labels }) => {
      Object.entries(section).forEach(([key, value]) => {
        if (value) {
          json.push({
            question: `${prefix} - ${labels[key]}`,
            answer: value
          });
        }
      });
    });
  
    // Feedback
    if (formData.feedback) {
      json.push({
        question: "Observer's feedback (Action Taken or Recommendation)",
        answer: formData.feedback
      });
    }
  
    // Stop Work Authority
    if (formData.stopWorkAuthority) {
      json.push({
        question: "Stop Work Authority (SWA) USED?",
        answer: formData.stopWorkAuthority
      });
    }
  
    // Client Joint Observation
    if (objimg) {
    const formDataa = new FormData();
formDataa.append('files', objimg);


let uploadedFiles = [];
  const imgresponse = await api.post('/v1/forms/upload-files', formDataa, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
if(imgresponse.status===200){

  // Safely extract uploaded file data
  uploadedFiles = Array.isArray(imgresponse?.files)
    ? imgresponse.files
    : [];

      json.push({
        question: "Client Joint Observation",
        answer: uploadedFiles[0]
      });
    }
    return json;
    }

  };
  const validateStep5 = () => {
    const requiredFields = {
      feedback: t("Please provide Feedback"),
      stopWorkAuthority: t("Please fill Stop Work Authority"),
    
    };
  
    for (let key in requiredFields) {
      if (!formData[key] || formData[key].trim() === '') {
        setSeverity("error");
        setAlertMessage(requiredFields[key]);
        setOpen(true);
        return false;
      }
    }
    if(!objimg){
      setSeverity("error");
      setAlertMessage(t("Please provide Client Joint Observation signature"));
      setOpen(true);
    }
  
    return true;
  };
  const handleSubmitform = async (formData) => {
    // if (!validateStep5()) return;
  
    try {
      setLoader(true);

      const jsonData =await generateJsonData(formData);
  let obj={
     
       companyid: formData.companyId,
        form_type: "BBS",
        job_id: formData.jobNumber,
        job_description: `${selectedJobName}-(${jobCode})`,
        observer_name: formData.observerName,
        filled_date:  transformDateToISO(formData.date),
        json_data: jsonData,
        documents: "",
        method:formData.method
      }
      if(formData.emp_Id){
        obj.emp_id=formData.emp_Id
        obj.emp_name= formData.observerName
      }
     let response;
      if(mode==="edit"&&id){
        obj.row_id=id
  response = await api.post('/v1/forms/create-update-form',obj );
      }else{

       response = await api.post('/v1/forms/create-form',obj );
      }

  
      if (response.status === 200) {
        setOpen(true);
        setSeverity("success");
        setAlertMessage('Submitted Successfully');
        setTimeout(() => {
          setOpen(false);
          navigate(-1);
        }, 2000);
      }
    } catch (error) {
      setSeverity("error");
      setAlertMessage('Something went wrong');
      setOpen(true);
      console.error("Submission error:", error);
    } finally {
      setLoader(false);
    }
  };
  

const fetchEmployeeSuggestions = async (query) => {
  try {
    if (!query) {
      setEmployeeSuggestions([]);
      setShowEmpSuggestions(false);
      return;
    }

    const obj = {
      params: {
        company_id:selectedCompanyId,
        empid: query
      },
    };

    const response = await api.get("/v1/timesheets/get-employee", obj);
    if (response.status === 200 && Array.isArray(response.data)) {
      setEmployeeSuggestions(response.data);
      setShowEmpSuggestions(true);
    }else{
      setEmployeeSuggestions([]);
      setShowEmpSuggestions(false);


    }
  } catch (error) {
    console.error("Error fetching employee suggestions:", error);
  }
};

const fetchJobSuggestions = async (query) => {
  try {
    if (!query) {
      setSuggestions([]);
      setShowSuggestions(false);
      setSelectedJobName('');
      return;
    }

    // If query is 0 to 4 zeros, return overhead job
    if (/^0{1,4}$/.test(query)) {
      const overheadJob = {
        job_num: "0000",
        job_name: "Overhead",
      };
      setSuggestions([overheadJob]);
      setShowSuggestions(true);
      return;
    }

    const response = await api.get(`/v1/timesheets/get-jobs`, {
      params: {
        company_id: selectedCompanyId,
        job_num: query,
      }
    });

    if (response.status === 200) {
      setSuggestions(response.data || []);
      setShowSuggestions(true);
    } else {
      setSuggestions([]);
      setShowSuggestions(false);
    }
  } catch (error) {
    console.error("Error fetching jobcodes:", error);
  }
};


const handleEmployeeSelect = (emp) => {
  setFormData((prev) => ({
    ...prev,
    observerName: `${emp.firstname} ${emp.lastname}`,
    emp_Id: emp.empid, // optional: if you want to store the ID
  }));
  setEmployeeId(emp.empid);
  setselectedempobj(emp);
  setShowEmpSuggestions(false);
  setEmployeeSuggestions([]);
};

const handleJobCodeSelect = (code) => {
  setJobCode(code.job_num);
  setSelectedJobName(code.job_name);
  setSuggestions([]);
  setShowSuggestions(false);

  // Also update formData.jobNumber
  setFormData((prev) => ({
    ...prev,
    jobNumber: code.job_num,
  }));
};

  const fetchTabsData = async () => {
    try {
      const response = await api.get(`/v1/timesheets/company-details`);
  
      if (response.status === 200 ) {
        setCompanyTabs(response.data);

        setSelectedCompanyId(response.data[0]?.id);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  
  useEffect(()=>{
    fetchTabsData()
  },[])

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (jobInputRef.current && !jobInputRef.current.contains(event.target)) {
        setShowSuggestions(false);
      }
 
      if (empInputRef.current && !empInputRef.current.contains(event.target)) {
        setShowEmpSuggestions(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

   const handleTabSelect = (e) => {
    if (e.key === 'Tab'&&suggestions?.length) {
      e.preventDefault(); // Prevent default tab behavior
      const selectedJob = suggestions[0];
      handleJobCodeSelect(selectedJob); // Select the hovered item
      setShowSuggestions(false); // Hide suggestions after selection
    }
  };
 
  const renderStageContent = () => {
    switch (currentStage) {
      case 1:
        return (
          <>
  
            <div className="py-2 px-4 bg-[black] w-full items-center flex mb-2">
              <h3 className="text-sm text-white font-inter font-semibold text-left">{t("Step 1:")} {t("Observer Information")}</h3>
            </div>
            <div className='bg-[#F9FAFB] p-4'>

         
            <div className='my-2 font-inter font-semibold text-left'>
             Observer Information 
            </div>
            <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6 ">
            <div>
            <div>
      <label className="block text-sm text-left font-medium">{t("Company ID")}</label>
      <select
  className="w-full border rounded px-3 py-[10px] text-sm font-inter mt-1"
  value={formData.companyId || ""}
  onChange={(e) => {
    const selectedId = e.target.value ? parseInt(e.target.value, 10) : null;
         setSelectedCompanyId(selectedId)
    setFormData((prev) => ({
      ...prev,
      companyId: selectedId,
    }));
  }}
>
  <option className="font-inter text-xs" value="">{t("Select a Company")}</option>
  {companyTabs.map((company) => (
    <option className="font-inter text-xs" key={company.id} value={company.id}>
      {t(company.name)}
    </option>
  ))}
</select>


            </div>
              </div>
              <div className="relative" ref={jobInputRef}>
                <label className="block text-sm font-medium mb-1 text-left">{t("JOB #")}</label>
                <input
                    placeholder='Enter job Id'
                  type="text"
                  className="w-full border border-gray-300 rounded p-2 text-sm"
                  value={formData.jobNumber}
                  onChange={(e) => {
                    const val = e.target.value;
   

                    handleInputChange({ target: { value: val } }, null, 'jobNumber');
                    
                    if (!val.trim()) {
                      setSuggestions([]);
                      setShowSuggestions(false);
                    } else {
                      fetchJobSuggestions(val); // your function to get suggestions
                      setShowSuggestions(true);
                    }
                  }}
                    onBlur={() => {
    const isValid = suggestions.some((s) => s.job_num === formData.jobNumber);
    if (!isValid) {
      setFormData((prev) => ({
        ...prev,
        jobNumber: '',
      }));
      setJobCode('');
      setSelectedJobName('');
    }
  }}
   onKeyDown={handleTabSelect} 
                />
                   {showSuggestions && suggestions.length > 0 && (
                <ul className="absolute z-10 mt-1 left-0 text-start bg-white border border-gray-200 rounded-md shadow-lg max-h-[400px] overflow-y-auto text-sm w-full whitespace-nowrap">
                  {suggestions.map((code, index) => (
                    <li
                      key={index}
                      onClick={() => handleJobCodeSelect(code)}
                     onMouseEnter={() => setHoveredIndex(index)} // Track hovered item
              className={`px-2 py-1 cursor-pointer hover:bg-gray-100 ${
                hoveredIndex === index ? 'bg-gray-100' : ''
              }`}
                     >
                      {code.job_num} - {code.job_name}
                    </li>
                  ))}
                </ul>
              )}
              </div>
              <div>
                <label className="block text-sm font-medium mb-1 text-left">{t("EMPLOYEE ID (Optional)")}</label>
                <div className="relative" ref={empInputRef}>
  <input
  type="text"
  placeholder="Enter employee Id"
  className="w-full border border-gray-300 rounded p-2 text-sm"
  value={formData.observerName}
  onChange={(e) => {
     const val = e.target.value.replace(/\D/g, ''); // Allow only numbers


handleInputChange(
  { ...e, target: { ...e.target, value: val } }, // Inject sanitized numeric-only value
  null,
  'observerName'
);

    if (!val.trim()) {
      setselectedempobj({});
      setEmployeeSuggestions([]);
      setShowEmpSuggestions(false);
    } else {
      fetchEmployeeSuggestions(val);
    }
  }}
  onBlur={() => {
    const isValid = employeeSuggestions.some(
      (emp) =>
        `${emp.firstname} ${emp.lastname}`.toLowerCase() ===
        formData.observerName.trim().toLowerCase()
    );
    if (!isValid) {
      setFormData((prev) => ({
        ...prev,
        observerName: '',
        emp_Id: null,
      }));
      setEmployeeId('');
      setselectedempobj({});
    }
  }}
  onKeyDown={(e) => {
    if (e.key === 'Tab') {
      if (hoveredIndex !== null&&employeeSuggestions?.length) {
        handleEmployeeSelect(employeeSuggestions[0]);
        e.preventDefault(); // Prevent the default behavior of tabbing out of the input
      }
    }

    if (e.key === 'ArrowDown') {
      setHoveredIndex((prevIndex) =>
        prevIndex === null || prevIndex === employeeSuggestions.length - 1
          ? 0
          : prevIndex + 1
      );
    }

    if (e.key === 'ArrowUp') {
      setHoveredIndex((prevIndex) =>
        prevIndex === null || prevIndex === 0
          ? employeeSuggestions.length - 1
          : prevIndex - 1
      );
    }
  }}
/>

  {showEmpSuggestions && employeeSuggestions.length > 0 && (
    <ul className="absolute z-10 mt-1 left-0 text-start bg-white border border-gray-200 rounded-md shadow-lg max-h-[300px] overflow-y-auto text-sm w-full">
      {employeeSuggestions.map((emp, index) => (
        <li
          key={index}
          onClick={() => handleEmployeeSelect(emp)}
         className={`px-2 py-1 cursor-pointer hover:bg-gray-100 ${
                index === hoveredIndex ? 'bg-gray-100' : ''
              }`}
              onMouseEnter={() => setHoveredIndex(index)}
        >
          {`${emp.firstname} ${emp.lastname}`} - {emp.empid}
        </li>
      ))}
    </ul>
  )}
                </div>

              </div>
              <div>
                <label className="block text-sm font-medium mb-1 text-left">{t('DATE')}</label>
              <DatePicker
  selected={formData.date ? new Date(formData.date) : null} // Convert string to Date object
  onChange={(date) =>
    handleInputChange(
      {
        target: {
          value: date
            ? `${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}-${date.getFullYear()}`
            : '',
        },
      },
      null,
      'date'
    ) // Format date as MM-dd-yyyy in local time
  }
  className="w-full border border-gray-300 rounded p-2 text-sm" // Match original input styling
  wrapperClassName="w-full" // Ensure full width for wrapper
  dateFormat="MM-dd-yyyy" // Display format as MM-dd-yyyy
  maxDate={new Date()} // Disables future dates
  placeholderText="MM-DD-YYYY" // Replace original placeholder
/>
              </div>
            </div>
         </div>
         <div className='p-4 border-t border-b'>
            <div className="flex items-center mb-2">
                <span className="text-red-500 font-semibold mr-2">ⓘ {t("BBS Instructions")} :</span>
              </div>
<div className="bg-red-50 border border-red-200 rounded p-4 mb-6">
            
              <p className="text-sm font-inter text-gray-600 text-left text-wrap">
                {t("BBS instructions: (1) Inform co-worker(s) that you are going to perform a BBS observation on the task they are performing. (2) Observe co-worker(s) performing task while paying attention to the Critical Factors Section. (3) After the observations provide feedback to co-worker(s) whether safe or concerning, some categories may NOT apply and are to be left blank. Promptly, after observations give this form to your supervisor who WILL review it and who must then forward it to the Safety Department")}
              </p>
            </div>
         </div>
            
      
            <div className='mt-4'>
              <label className="block text-sm font-medium font-inter mb-1 text-left">
                {t("What task(s) were employee(s) performing during the BBS observation?")}
              </label>
              <textarea
                className="w-full border border-gray-300 rounded p-2 text-sm"
                rows="4"
                value={formData.taskDescription}
                onChange={(e) => handleInputChange(e, null, 'taskDescription')}
              />
            </div>
            <div className='w-[15%]'>
      <label className="block text-sm text-left font-medium">{t("Method")}</label>
      <select
  className="w-full border rounded px-3 py-[10px]  text-sm font-inter mt-1"
  value={formData.method || ""}
  onChange={(e) => {
    setFormData((prev) => ({
      ...prev,
      method: e.target.value,
    }));
  }}
>
  <option className="font-inter text-xs" value="">{t("Select Method")}</option>
  <option className="font-inter text-xs" value="Filled Out">{t("Filled Out")}</option>
  <option className="font-inter text-xs" value="Uploaded">{t("Uploaded")}</option>
  <option className="font-inter text-xs" value="Capture">{t("Capture")}</option>
</select>
    </div>
          </>
        );

      case 2:
        return (
          <>
            <div className="py-2 px-4 bg-[black] w-full items-center flex mb-2">
              <h3 className="text-sm text-white font-inter font-semibold text-left">{t("Step 2:")} {t("Personal Protective Equipment (PPE)")}</h3>
            </div>
            <div className="mb-6 mt-2">
              <div className="flex items-center py-2 bg-[black] justify-center my-1">
                <span className="text-white font-semibold mr-2 text-sm uppercase">{t("Critical Factors")}</span>
                <span className="text-white mr-2 text-xs uppercase"> {t("S=Safe C=Concern")}</span>
              </div>
              <div className="text-sm font-medium py-2 bg-gray-100 px-3 text-left">{t("1. PPE")}</div>
              {[
                { label: 'A. Eye & Face', id: 'eyeFace', field: 'eyeFace' },
                { label: 'B. Hand', id: 'hand', field: 'hand' },
                { label: 'C. Body', id: 'body', field: 'body' },
                { label: 'D. Head', id: 'head', field: 'head' },
                { label: 'E. Respiratory', id: 'respiratory', field: 'respiratory' },
                { label: 'F. Hearing', id: 'hearing', field: 'hearing' },
              ].map((item) => (
                
                <div key={item.id} className="flex items-center font-inter my-4 border-b w-[100%] pl-4 pr-40 justify-between py-1">
<label className="text-sm text-left font-medium w-45">
  <span className="text-red-500">{t(item.label)?.charAt(0)}</span>
  <span className="text-black">{t(item.label)?.slice(1)}</span>

</label>
                  <div className="flex items-center ml-4">
                    <div className="flex items-center mr-4">
                      <input
                        type="radio"
                        name={item.id}
                        className="mr-2 w-3 h-3 cursor-pointer"
                        checked={formData.ppe[item.field] === 'S'}
                        onChange={() => handleRadioChange('ppe', item.field, 'S')}
                      />
                      <span className="text-sm text-green-600 font-medium">S</span>
                    </div>
                    <div className="flex items-center">
                      <input
                        type="radio"
                        name={item.id}
                        className="mr-2 w-3 h-3 cursor-pointer"
                        checked={formData.ppe[item.field] === 'C'}
                        onChange={() => handleRadioChange('ppe', item.field, 'C')}
                      />
                      <span className="text-sm text-red-500 font-medium">C</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </>
        );

      case 3:
        return (
          <>
            <div className="py-2 px-4 bg-[black] w-full items-center flex mb-2">
              <h3 className="text-sm text-white font-inter font-semibold text-left">{t("Step 3: Body Position")}</h3>
            </div>
            <div className="mb-6">
              <div className="flex items-center py-2 bg-[black] justify-center my-1">
                <span className="text-white font-semibold mr-2 text-sm uppercase">{t("Critical Factors")}</span>
                <span className="text-white mr-2 text-xs uppercase"> {t("S=Safe C=Concern")}</span>
              </div>
              <div className="text-sm font-medium py-2 bg-gray-100 px-3 text-left">{t("2. BODY POSITION")}</div>
              {[
                { label: 'A. Proper Body Positioning (Line of fire)', id: 'properBodyPositioning', field: 'properBodyPositioning' },
                { label: 'B. Manual lifting mechanics', id: 'manualLifting', field: 'manualLifting' },
                { label: 'C. Repetition', id: 'repetition', field: 'repetition' },
                { label: 'D. Pinch Points', id: 'pinchPoints', field: 'pinchPoints' },
                { label: 'E. Pulling/Pushing', id: 'pullingPushing', field: 'pullingPushing' },
                { label: 'F. Extending', id: 'extending', field: 'extending' },
              ].map((item) => (
                <div key={item.id} className="flex items-center font-inter my-4 border-b w-[100%] pl-4 pr-40 justify-between py-1">
<label className="text-sm text-left font-medium w-45">
  <span className="text-red-500">{t(item.label)?.charAt(0)}</span>
  <span className="text-black">{t(item.label)?.slice(1)}</span>
</label>
                  <div className="flex items-center ml-4">
                    <div className="flex items-center mr-4">
                      <input
                        type="radio"
                        name={item.id}
                        className="mr-2 w-3 h-3 cursor-pointer"
                        checked={formData.bodyPosition[item.field] === 'S'}
                        onChange={() => handleRadioChange('bodyPosition', item.field, 'S')}
                      />
                      <span className="text-sm text-green-600 font-medium">S</span>
                    </div>
                    <div className="flex items-center">
                      <input
                        type="radio"
                        name={item.id}
                        className="mr-2 w-3 h-3 cursor-pointer"
                        checked={formData.bodyPosition[item.field] === 'C'}
                        onChange={() => handleRadioChange('bodyPosition', item.field, 'C')}
                      />
                      <span className="text-sm text-red-500 font-medium">C</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </>
        );

      case 4:
        return (
          <>
            <div className="py-2 px-4 bg-[black] w-full items-center flex mb-2">
              <h3 className="text-sm text-white font-inter font-semibold text-left">{t("Step 4: Work Environment & Procedures")}</h3>
            </div>
            <div className="mb-6">
              <div className="flex items-center py-2 bg-[black] justify-center my-1">
                <span className="text-white font-semibold mr-2 text-sm uppercase">{t("Critical Factors")}</span>
                <span className="text-white mr-2 text-xs uppercase"> {t("S=Safe C=Concern")}</span>
              </div>
              <div className="text-sm font-medium mb-2 bg-gray-100 p-2 text-left">{t("3. WORK ENVIRONMENT")}</div>
              {[
                { label: 'A. Slips, Trips, Falls', id: 'slipsTripsFalls', field: 'slipsTripsFalls' },
                { label: 'B. Congested Work Area', id: 'congestedWorkArea', field: 'congestedWorkArea' },
                { label: 'C. Barricades/Signage', id: 'barricadesSignage', field: 'barricadesSignage' },
                { label: 'D. Excavations', id: 'excavations', field: 'excavations' },
                { label: 'E. Fall Protection', id: 'fallProtection', field: 'fallProtection' },
                { label: 'F. Spill Control', id: 'spillControl', field: 'spillControl' },
              ].map((item) => (
                <div key={item.id} className="flex items-center font-inter my-4 border-b w-[100%] pl-4 pr-40 justify-between py-1">
<label className="text-sm text-left font-medium w-45">
<span className="text-red-500">{t(item.label)?.charAt(0)}</span>
<span className="text-black">{t(item.label)?.slice(1)}</span>
</label>
                  <div className="flex items-center ml-4">
                    <div className="flex items-center mr-4">
                      <input
                        type="radio"
                        name={item.id}
                        className="mr-2 w-3 h-3 cursor-pointer"
                        checked={formData.workEnvironment[item.field] === 'S'}
                        onChange={() => handleRadioChange('workEnvironment', item.field, 'S')}
                      />
                      <span className="text-sm text-green-600 font-medium">S</span>
                    </div>
                    <div className="flex items-center">
                      <input
                        type="radio"
                        name={item.id}
                        className="mr-2 w-3 h-3 cursor-pointer"
                        checked={formData.workEnvironment[item.field] === 'C'}
                        onChange={() => handleRadioChange('workEnvironment', item.field, 'C')}
                      />
                      <span className="text-sm text-red-500 font-medium">C</span>
                    </div>
                  </div>
                </div>
              ))}
              <div className="text-sm font-medium mb-2 text-left bg-gray-100 py-2 px-2">{t("4. WORK PROCEDURES")}</div>
              {[
                { label: 'A. JSA Cover Task', id: 'jsaCoverTask', field: 'jsaCoverTask' },
                { label: 'B. Hazard Recognition', id: 'hazardRecognition', field: 'hazardRecognition' },
                { label: 'C. Energy Isolation (LOTO)', id: 'energyIsolation', field: 'energyIsolation' },
                { label: 'D. Simultaneous Operations (SIMOPS)', id: 'simultaneousOperations', field: 'simultaneousOperations' },
                { label: 'E. Hand/Power Tools', id: 'handPowerTools', field: 'handPowerTools' },
                { label: 'F. Mobile Equipment', id: 'mobileEquipment', field: 'mobileEquipment' },
              ].map((item) => (
                <div key={item.id} className="flex items-center font-inter my-4 border-b w-[100%] pl-4 pr-40 justify-between py-1">
<label className="text-sm text-left font-medium w-45">
<span className="text-red-500">{t(item.label)?.charAt(0)}</span>
<span className="text-black">{t(item.label)?.slice(1)}</span>
</label>
                  <div className="flex items-center ml-4">
                    <div className="flex items-center mr-4">
                      <input
                        type="radio"
                        name={item.id}
                        className="mr-2 w-3 h-3 cursor-pointer"
                        checked={formData.workProcedures[item.field] === 'S'}
                        onChange={() => handleRadioChange('workProcedures', item.field, 'S')}
                      />
                      <span className="text-sm text-green-600 font-medium">S</span>
                    </div>
                    <div className="flex items-center">
                      <input
                        type="radio"
                        name={item.id}
                        className="mr-2 w-3 h-3 cursor-pointer"
                        checked={formData.workProcedures[item.field] === 'C'}
                        onChange={() => handleRadioChange('workProcedures', item.field, 'C')}
                      />
                      <span className="text-sm text-red-500 font-medium">C</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </>
        );

      case 5:
        return (
          <>
            <div className="py-2 px-4 bg-black w-full flex items-center mb-2">
              <h3 className="text-sm text-white font-inter font-semibold text-left">
                {t('Step 5: Feedback & Submission')}
              </h3>
            </div>

            <div className="py-2 px-4 bg-black w-full flex justify-center items-center mb-2">
              <span className="text-md text-white font-inter font-semibold">
                {t("IMPROVEMENT INPUT")}
              </span>
            </div>

            <div className="bg-white  rounded-md p-4 mb-6">
              <label className="block text-xs font-inter font-medium text-gray-700 mb-2 text-left">
              {t("Observer's feedback (Action Taken or Recommendation) given to other employee(s):")}
              </label>
              <textarea
                placeholder='Enter your feedback and recommendations...'
                className="w-full border border-gray-300 rounded p-2 text-sm focus:outline-none focus:ring-2 focus:ring-black"
                rows="4"
                value={formData.feedback}
                onChange={(e) => handleInputChange(e, null, 'feedback')}
              />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6 bg-gray-100 p-4 py-6 border-t border-b">
            <div className="flex flex-col">
  <label className="block text-xs text-[#374151] font-inter font-medium mb-2 text-left">
  {t("Stop Work Authority (SWA) USED?")}
  </label>
  <div className="flex gap-4">
    <label className="flex items-center text-sm font-medium">
      <input
        type="checkbox"
        name="stopWorkAuthority"
        className="mr-2 cursor-pointer"
        value="YES"
        checked={formData.stopWorkAuthority === 'YES'}
        onChange={(e) => handleRadioChange(null, 'stopWorkAuthority', e.target.value)}
      />
      {t("YES")}
    </label>
    <label className="flex items-center text-sm font-medium">
      <input
        type="checkbox"
        name="stopWorkAuthority"
        className="mr-2 cursor-pointer"
        value="NO"
        checked={formData.stopWorkAuthority === 'NO'}
        onChange={(e) => handleRadioChange(null, 'stopWorkAuthority', e.target.value)}
      />
     {t("NO")}
    </label>
  </div>
</div>
              <div className="flex flex-col border-l pl-4">
                <label className="block text-xs text-[#374151] font-inter font-medium mb-2 text-left">
                  {t("CLIENT JOINT OBSERVATION? SIGN BELOW")}
                </label>
                <input
                  type="text"
                  className="border border-gray-300 rounded p-2 text-sm w-full"
                  onClick={()=>setSignatureModal(true)}
                  // value={formData.clientJointObservation}
                  // onChange={(e) => handleInputChange(e, null, 'clientJointObservation')}
                />
              </div>
                   <div className="flex flex-col items-center p-4 border border-gray-300 rounded-md bg-white shadow-sm ">
    <span className="text-sm font-medium text-gray-700 mb-3">
{t('CLIENT JOINT OBSERVATION SIGNATURE')}
    </span>
    {objimg? (
      <img
        className="w-40 h-24 object-contain border border-gray-200 rounded-md bg-white"
        src={
          objimg instanceof File
            ? URL.createObjectURL(objimg)
            :objimg
        }
        alt="Supervisor Signature"
        onLoad={(e) => {
          if (objimg instanceof File) {
            URL.revokeObjectURL(e.target.src);
          }
        }}
      />
    ) :editedimg?(<> <img
        className="w-40 h-24 object-contain border border-gray-200 rounded-md bg-white"
        src={`https://hub2.ntactops.com/ntact/files/forms_files/${editedimg?.file_name}`}
        alt="Supervisor Signature"
        // onLoad={(e) => {
        //   if (objimg instanceof File) {
        //     URL.revokeObjectURL(e.target.src);
        //   }
        // }}
      /></>): (
      <div className="w-40 h-24 flex items-center justify-center border border-gray-200 rounded-md bg-gray-100 text-gray-400 text-xs">
        No signature
      </div>
    )}
  </div>
            </div>


            <div className=" p-4 bg-gray-100 mb-6 rounded-br-xl rounded-bl-xl">
              <div className="flex items-center mb-4">
                <img src={documentData} className='w-5 h-5' alt='#gkk'/>
                
                <h2 className="text-md ml-2  font-inter text-gray-700">
                 {t("Document Information")}
                </h2>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm font-inter border bg-white rounded-md p-4">
                <div className='flex flex-col text-left'>
                  <p className="font-semibold font-inter mb-2">{t("HEALTH SAFETY & ENVIRONMENTAL")}</p>
                  <p className="mb-1 text-[#4B5563]">{t("Revision")} 1</p>
                  <p className='text-[#4B5563]'>
  {t("Date")}: {formData.date || new Date().toISOString().split('T')[0]}
</p>

                </div>

                <div className='flex flex-col text-left'>
                  <p className="font-semibold font-inter mb-2">{t("Document Details")}</p>
                  <p className="mb-1 ">
                    {t("Document")}: {t("Name:")} <span className="font-normal ml-16">{t("BBS SAFETY OBSERVATION FORM")}</span>
                  </p>
                  <p className="mb-1">
                  {t("Section")}: <span className="font-normal ml-20">HSE-7</span>
                  </p>
                  <p>
                   {t("Document Number")}: <span className="font-normal ml-2">7-5-A</span>
                  </p>
                </div>
              </div>
            </div>
          </>
        );

      default:
        return null;
    }
  };

  return (
    <div className="bg-gray-50 min-h-screen p-4 flex items-center flex-col">
      <div className="flex items-center mb-6 w-full">
        <FiArrowLeft onClick={() => navigate(-1)} className="text-xl mr-4 cursor-pointer" />
        <div className="flex flex-col text-xs">
          <h1 className="font-inter font-bold text-[22px]">{t("BBS SAFETY OBSERVATION FORM")}</h1>
          <p className="text-left">{t("Document safety observations and behaviors")}</p>
        </div>
      </div>

      <div className="flex justify-between mb-6 px-4 w-[80%]">
        {['Observer Info', 'PPE', 'Body Position', 'Work', 'Feedback'].map((label, index) => (
          <div key={index} className="flex flex-col items-center">
            <div
              className={`w-8 h-8 rounded-full ${
                currentStage === index + 1 ? 'bg-black text-white' : 'bg-gray-200 text-black'
              } flex items-center justify-center`}
            >
              {index + 1}
            </div>
            <span className="text-xs mt-1">{t(label)}</span>
          </div>
        ))}
      </div>

      <div className="bg-white w-full max-w-5xl mx-auto shadow-lg rounded-lg p-6 border-[1.5px] border-gray-100">
        <div className="flex flex-col w-full justify-between items-center mb-4">
          <div className="flex flex-col bg-[black] text-left px-4 py-6 w-full rounded-tr-xl rounded-tl-xl">
            <h2 className="text-lg font-inter text-white font-semibold">{t('BEHAVIOR BASED SAFETY (BBS) CARD')}</h2>
            <div className="text-white text-xs">{t('Record and report safety observations and behaviors')}</div>
          </div>
          <div className="mt-4 flex justify-end w-full">
      <button
        onClick={() => changeLanguage('en')}
        className={`px-3 py-1 rounded ${selectedLanguage === 'en' ? 'bg-black text-white' : 'bg-white text-black border border-gray-300'}`}
      >
        English
      </button>
      <button
        onClick={() => changeLanguage('es')}
        className={`px-3 py-1 rounded ${selectedLanguage === 'es' ? 'bg-black text-white' : 'bg-white text-black border border-gray-300'}`}
      >
        Español
      </button>
    </div>
        </div>

        {renderStageContent()}

        <div className="flex justify-between mt-6">
          <button
            onClick={handlePrevious}
            className={`flex items-center gap-2 px-4 py-2 rounded ${
              currentStage === 1 ? 'bg-gray-300 text-gray-500 cursor-not-allowed' : 'bg-black text-white'
            }`}
            disabled={currentStage === 1}
          >
            <span>←</span>
            {t("Previous Page")}
          </button>
          {currentStage === totalStages ? (
            <button
              onClick={() => {
                console.log('Final form data:', formData);
                handleSubmitform(formData);
              }}
              className="flex items-center gap-2 px-4 py-2 rounded bg-green-600 text-white"
            >
              <span className="flex items-center justify-center w-4 h-4 rounded-full border text-white text-green-600">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-3 h-3"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth={3}
                >
                  <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                </svg>
              </span>
              {t('Submit')} {t('Form')}
            </button>
          ) : (
            <button
              onClick={handleNext}
              className="flex items-center gap-2 px-4 py-2 rounded bg-black text-white"
            >
             {t("Next Page")}
              <span>→</span>
            </button>
          )}
        </div>
      </div>
      <ToastMessage message={alertmessage} severity={severity} open={open} handleClose={handleCloseToast} />
<SignatureModal isModal={signaturemodal} setModal={setSignatureModal} onSave={HandleSignature} />
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loader}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
};

export default BBSObservationForm;